export default "__VITE_ASSET__BmE$feVa__"